/****************************************************************************
 * Copyright 2018 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import React from 'react'
import { connect } from 'react-redux'
import { updateBaseInfo } from '../../state/toolbar'
import Dialog from '../../component/dialog'
import AbbrMap from '../../config.abbr'
import { initClipboard } from '../../state/hotkeys'
// import { onAction, load } from '../../state/shared';
class AbbrLib extends React.Component {
  onResult = () => {
    let { abbrText } = this.props
    abbrText = abbrText.trim()
    if (!abbrText) {
      alert('未找到结构')
      return
    }
    const dstVal = AbbrMap[abbrText.toLowerCase()]
    if (!dstVal) {
      alert('未找到结构')
      return
    }
    this.props.editor.tool('atom', { label: abbrText })
    this.dialog.exit()
    // this.props.onPaste({
    //   'text/plain': dstVal
    // })
  }
  onCancelClick = () => {
    this.props.editor.selection(null)
    this.dialog.exit('cancel')
  }
  componentWillUnmount = () => {
    this.props.updateBaseInfo({
      abbrText: ''
    })
  }
  render() {
    const { abbrText, ...prop } = this.props
    return (
      <Dialog
        title="Abbr."
        ref={el => {
          this.dialog = el
        }}
        className="about"
        params={prop}
        buttons={[
          <button onClick={this.onCancelClick}>Cancel</button>,
          <button onClick={this.onResult}>ok</button>
        ]}>
        <div style={{ paddingLeft: 10 }}>
          <input
            type="text"
            placeholder="abbr."
            value={abbrText}
            style={{ width: '95%' }}
            onInput={e => {
              prop.updateBaseInfo({
                abbrText: e.target.value
              })
            }}
          />
        </div>
      </Dialog>
    )
  }
}

export default connect(
  store => ({ ...store.toolbar, editor: store.editor }),
  dispatch => ({
    updateBaseInfo: newState => dispatch(updateBaseInfo(newState)),
    ...dispatch(initClipboard)
  })
)(AbbrLib)
